export default __webpack_public_path__ + "static/media/user.7a2df89b.svg";